import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { format } from "date-fns";
import NotificationSnackbar from "../../../../common/notificationBar/notification-snackbar";

const TasksExportSafe = ({ filteredTasks }) => {
  const [openExportSnackbar, setExportOpenSnackbar] = useState(false);

  const renderTable = (doc, title, data, columns, startY = null) => {
    if (startY) doc.setPage(doc.internal.getNumberOfPages());

    doc.setFontSize(14);
    doc.text(title, 14, startY || doc.lastAutoTable?.finalY + 10 || 30);

    autoTable(doc, {
      head: [columns],
      body: data,
      startY: startY || doc.lastAutoTable?.finalY + 15,
    });
  };

  const formatDateSafe = (dateValue) => {
    try {
      const parsed = new Date(dateValue);
      if (!parsed || isNaN(parsed)) return "N/A";
      return format(parsed, "dd MMM yyyy HH:mm");
    } catch {
      return "N/A";
    }
  };

  const flattenJSON = (jsonObj) =>
    Object.entries(jsonObj || {}).map(([key, value]) => {
      if (typeof value === "object" && value !== null) {
        try {
          return [key, JSON.stringify(value, null, 2)];
        } catch {
          return [key, "[Invalid JSON]"];
        }
      } else {
        return [key, String(value)];
      }
    });

  const handleExportToPDF = () => {
    if (!filteredTasks) return;

    const doc = new jsPDF();
    const formattedDate = formatDateSafe(new Date());

    doc.setFontSize(18);
    doc.text("Non-Physical Incident Report", 14, 20);

    const {
      temperature,
      whoWasAround,
      incidentCategory,
      gender,
      updated_at,
      uploadedImages,
      nonPhysicalWitnessInfo,
      nonPhysicalBehaviouralInfo,
      nonPhysicalStrategyInfo,
      nonPhysicalDetailInfo,
      afterIncidentInfo,
      antecedentBehaviourInfo,
      nonPhysicalChallengeInfo,
      nonPhysicalIncidentInfo,
      nonIncidentManagementInfo,
    } = filteredTasks;

    const generalTable = [
      ["Updated At", formatDateSafe(updated_at)],
      ["Gender", gender || "N/A"],
      ["Temperature", temperature || "N/A"],
      ["Who Was Around", whoWasAround || "N/A"],
      ["Incident Category", incidentCategory || "N/A"],
    ];

    autoTable(doc, {
      startY: 30,
      head: [],
      body: generalTable,
      theme: "plain",
      styles: { fontSize: 12 },
    });

    renderTable(doc, "Incident Management Info", flattenJSON(nonIncidentManagementInfo), ["Field", "Value"]);
    renderTable(doc, "Witness Info", flattenJSON(nonPhysicalWitnessInfo), ["Field", "Value"]);
    renderTable(doc, "Behavioural Info", flattenJSON(nonPhysicalBehaviouralInfo), ["Field", "Value"]);
    renderTable(doc, "Strategy Info", flattenJSON(nonPhysicalStrategyInfo), ["Field", "Value"]);
    renderTable(doc, "Detail Info", flattenJSON(nonPhysicalDetailInfo), ["Field", "Value"]);
    renderTable(doc, "After Incident Info", flattenJSON(afterIncidentInfo), ["Field", "Value"]);
    renderTable(doc, "Antecedent Behaviour Info", flattenJSON(antecedentBehaviourInfo), ["Field", "Value"]);
    renderTable(doc, "Challenging Behaviour Info", flattenJSON(nonPhysicalChallengeInfo), ["Field", "Value"]);
    renderTable(doc, "Incident Details", flattenJSON(nonPhysicalIncidentInfo), ["Field", "Value"]);
    renderTable(doc, "Uploaded Images", flattenJSON(uploadedImages), ["Field", "Value"]);

    doc.save(`non-physical-incident-${formattedDate}.pdf`);
    setExportOpenSnackbar(true);
  };

  return (
    <Box>
      <Typography variant='subtitle1' sx={{ fontSize: "18px", fontWeight: "bold" }} align='left'>
        Export Non-Physical Incident
      </Typography>
      <Typography variant='body2' sx={{ fontSize: "14px", mb: 3 }} align='left'>
        Click below to export a complete non-physical incident report.
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={handleExportToPDF}
        sx={{ width: "100%", textTransform: "none" }}
      >
        Export
      </Button>
      <NotificationSnackbar
        open={openExportSnackbar}
        onClose={() => setExportOpenSnackbar(false)}
        color='success'
        message='Report exported successfully.'
      />
    </Box>
  );
};

export default TasksExportSafe;
